import { render } from "./pull_quote.vue?vue&type=template&id=2d9e21b3&lang=pug"
import script from "./pull_quote.vue?vue&type=script&lang=js"
export * from "./pull_quote.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__